import { useState } from "react"
import { Link, useLocation } from "react-router"
import { Mail, ArrowLeft } from "lucide-react"
import { Button } from "@/components/ui/button"
import { apiClient } from "@/lib/api"

export function CheckInboxPage() {
  const location = useLocation()
  const email = (location.state as { email?: string })?.email || "your email"
  const [resent, setResent] = useState(false)

  const handleResend = async () => {
    try {
      await apiClient.resendActivation(email)
    } catch {
      // best effort — don't show error for resend
    }
    setResent(true)
    setTimeout(() => setResent(false), 4000)
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-[400px] text-center">
        {/* Icon */}
        <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
          <Mail className="h-6 w-6 text-primary" />
        </div>

        <h1 className="text-xl font-semibold text-foreground mb-2">Check your inbox</h1>
        <p className="text-sm text-muted-foreground leading-relaxed mb-1">
          We sent a confirmation link to
        </p>
        <p className="text-sm font-medium text-foreground mb-6">{email}</p>

        <p className="text-sm text-muted-foreground leading-relaxed mb-6">
          Click the link in the email to activate your account. It may take a minute to arrive.
        </p>

        {/* Resend */}
        <Button
          variant="outline"
          className="w-full mb-3"
          onClick={handleResend}
          disabled={resent}
        >
          {resent ? "Email resent" : "Resend confirmation email"}
        </Button>

        {/* Wrong email */}
        <Link
          to="/sign-up"
          className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Wrong email? Go back
        </Link>
      </div>
    </div>
  )
}
